"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var wx_h5_to_miniprogram_btn_1 = __importDefault(require("./wx-h5-to-miniprogram-btn"));
// 用于跳转标签获取传入组件的宽高
function WxH5ToMiniProgramContainer(props) {
    var globalPadId = props.globalPadId, destinationUrl = props.destinationUrl, currentUrl = props.currentUrl, debug = props.debug, content = props.content, style = props.style, className = props.className, reportTdwWhenExp = props.reportTdwWhenExp, reportTdwWhenClk = props.reportTdwWhenClk;
    var contentRef = react_1.default.createRef();
    /** 如果没有提供包装content，直接返回null */
    if (!content) {
        return null;
    }
    return (react_1.default.createElement("div", { className: className || '', style: __assign(__assign({}, style), { position: 'relative' }) },
        react_1.default.createElement("div", { ref: contentRef }, content),
        react_1.default.createElement(wx_h5_to_miniprogram_btn_1.default, { siblingRef: contentRef, globalPadId: globalPadId, destinationUrl: destinationUrl, currentUrl: currentUrl, debug: debug ? 1 : 0, reportTdwWhenExp: reportTdwWhenExp, reportTdwWhenClk: reportTdwWhenClk })));
}
exports.default = WxH5ToMiniProgramContainer;
